<nav-bar></nav-bar>
<div class="layout">
  <router-outlet></router-outlet>
</div>
